import useAuth from './useAuth';

export const useMixpanelUser = () => {
  const { user } = useAuth();
  
  const getUserEmail = (): string | undefined => {
    if (!user || !user.isLoggedIn) {
      return undefined;
    }
    return localStorage.getItem('userEmail') || undefined;
  };
  
  const getUserId = (): string | undefined => {
    if (!user || !user.isLoggedIn) {
      return undefined;
    }
    
    return user.name && typeof user.name === 'string' 
      ? `user_${user.name.replace(/\s+/g, '_').toLowerCase()}` 
      : `user_${user.isAdmin ? 'admin' : 'user'}`;
  };
  
  const getUserProperties = () => {
    if (!user || !user.isLoggedIn) {
      return {};
    }
    
    return {
      name: user.name || 'Unknown User',
      is_admin: user.isAdmin,
      login_status: 'authenticated'
    };
  };
  
  return {
    userId: getUserId(),
    userProperties: getUserProperties(),
    userEmail: getUserEmail(),
    isAuthenticated: user?.isLoggedIn || false
  };
};
